export default "__VITE_ASSET__DEd9XyfG__"